import { CategoryPricingCard } from "@components"
import { Card, RealTimeQuoteType, SectionTitleType } from "@types"
import * as React from "react"
import { Dispatch, SetStateAction } from "react"

interface MostPopularAllCategoryProps {
  sections?: SectionTitleType[]
  setSelectedCard: Dispatch<SetStateAction<Card | undefined>>
  setShowQuote: Dispatch<SetStateAction<boolean>>
}

export const MostPopularAllCategory = ({
  sections,
  setSelectedCard,
  setShowQuote,
}: MostPopularAllCategoryProps) => {
  return (
    <>
      {sections &&
        sections?.map((section: SectionTitleType) => (
          <div className="mt-10 mb-5 pt-10 container mx-auto">
            <h2 className="text-black pb-10 lg:text-2xl text-xl font-semibold text-center">
              {section.title}{" "}
              <span className="text-gradient-tertiary">
                {section.sectionSubDescription}
              </span>
            </h2>
            <div className="grid-container-18 gap-3">
              {section?.cards &&
                section?.cards.map((cards: Card) => (
                  <CategoryPricingCard
                    setSelectedCard={setSelectedCard}
                    cards={cards}
                    setShowQuote={setShowQuote}
                  />
                ))}
            </div>
          </div>
        ))}
    </>
  )
}
